import { get } from "lodash";

export const getCredentialSubmissionErrorMessage = (e: any) =>
  get(
    JSON.parse(e.message),
    "__all__",
    "There was a problem with your submission. Please try again later.",
  );
